import ApiConstants from "../constants/ApiConstants";

export default class Auth {
    private static _authInstance = null;
    private static statusCallPromise = null;
  
    constructor() {}
  
    public static getInstance(): Auth {
      if (!Auth._authInstance) {
        Auth._authInstance = new Auth();
      }
      return Auth._authInstance;
    }
  
    public static clearStoredStatusCall() {
      Auth.statusCallPromise = null;
    }
  
    public static async checkIfUserLoggedIn() {
      /* For avoiding parallel status calls */
      if (Auth.statusCallPromise) {
        return Auth.statusCallPromise;
      }
  
      Auth.statusCallPromise = fetch(
        ApiConstants.URL.BASE + ApiConstants.URL.IAM.STATUS,
        {
          method: "GET",
          credentials: "include",
          mode: "cors",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          Auth.clearStoredStatusCall();
          return response.json();
        })
        .catch((error) => {
          return error;
        });
  
      return Auth.statusCallPromise;
    }
  }
  